import { LibService } from './libService';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { UserSessionService } from './user-session.service';
import { GuardService } from './guard.service';
import { AuthService } from '../auth/auth.service'

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends BaseService {

  constructor(
    public LibService: LibService,
    public AuthService: AuthService,
    public userSessionService: UserSessionService,
    public guardService: GuardService
  ) {
    super(LibService, AuthService)
    this.baseApi = environment.rootApiFoundation
    this.model = 'categories'
  }

  createCategory(category: any): Observable<any> {
    return this.libService.postData<any>(category, this.baseApi, 'categories');
  }

  updateCategory(category: any): Observable<any> {
    return this.libService.putData<any>(category, this.baseApi, `categories/${category.id.toString()}`);
  }

  deleteCategory(category: any): Observable<any> {
    return this.libService.deleteData<any>(category, this.baseApi, `categories/${category.id.toString()}`);
  }

  getAllCategories(): Observable<any> {
    console.log(this.baseApi);
    return this.libService.getData<any>(this.baseApi, 'categories/');
  }

  getCategory(id: string) {
    return this.libService.getData<any>(this.baseApi, `categories/${id.toString()}`);
  }

  getCategoriesByLangCode(code: string) {
    return this.libService.getData<any>(this.baseApi, `categories/langcode/${code.toString()}`);
  }

  withCompanyAndBranch(companyId: any, branchId: any) {
    return this.libService.getDataWithAccessToken<any>(this.tokenId, this.baseApi, `categories/withCompanyAndBranch/${companyId}/${branchId}`);
  }
}